
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-marketing",
      function () {
        return require("private-next-pages/ai-marketing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-marketing"])
      });
    }
  